module.exports = __webpack_public_path__ + "static/media/Kit_Prot-AoN22.5553937d.png";